"use client";

import { useCallback } from "react";
import type { HomePageControllerLocal } from "./domain/home-page/types";

type HomePageFooterHandlersLocal = Pick<
  HomePageControllerLocal,
  "handleAboutUsClick" | "handleContactClick" | "handleRevealEmailClick"
>;

export function useHomePageFooterHandlers(): HomePageFooterHandlersLocal {
  const handleContactClick = useCallback(() => undefined, []);
  const handleRevealEmailClick = useCallback(() => undefined, []);
  const handleAboutUsClick = useCallback(() => undefined, []);

  return {
    handleAboutUsClick,
    handleContactClick,
    handleRevealEmailClick,
  };
}
